// extracted by mini-css-extract-plugin
export default {"text":"iKO5z","normal":"jZqzd","bulleted":"qRkwR","quote":"SKfST"};